import { GetTierLevelModel } from "@factory/model/query-model-tier-level";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { tierLevelFormDefault } from "./form.default";
import { TierLevelFormSchema } from "./form.rule";

export const useFormDefaultTierLevel = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTierLevelModel | undefined) => {
    return !cachedValue
      ? tierLevelFormDefault
     : ({
        tenant: cachedValue.tenant,
        name: cachedValue.name,
        level: cachedValue.level,
        minAmount: cachedValue.min_amount,
        maxAmount: cachedValue.max_amount,
        description: cachedValue.description,
      } as TierLevelFormSchema);
  };

  return {
    getDefault,
  };
};
